import stringToColor from 'string-to-color';
import Color from 'color';

export const getSkillColors = (skill) => {
  const baseHex = stringToColor(skill.toLowerCase());
  let base = Color(baseHex);

  const hsl = base.hsl();
  const lighterColor = Color.hsl(hsl.color[0], hsl.color[1], 70);

  const bgColor = lighterColor.alpha(0.55).rgb().string(); 
  const borderColor = hsl.hex();

  return {
    bgColor,
    borderColor,
  };
};
